import {connect} from 'react-redux'
import Board from '../components/board'
import {
  closeHint,
  removeCard,
  toggleCardActive,
  setActiveField,
  setChosenCard,
  calculateOdds,
  reset,
  getWinnerHand,
  setWinner,
  setBoardCarousel,
} from "../actions"
import {getPreparedBoardProps} from "../helpers/board"

const mapDispatchToProps = (dispatch) => {
  return {
    removeCard: (rank, suit, type) => {
      dispatch(removeCard(rank, suit, type));
      dispatch(toggleCardActive(rank, suit, true));
    },
    closeHint: (type) => {
      dispatch(closeHint(type));
    },
    setActiveField: (type, id, isCardClicked) => {
      dispatch(setActiveField(type, id, isCardClicked));
    },
    setBoardCarousel: (carousel) => {
      dispatch(setBoardCarousel(carousel));
    },
    setChosenCard: (type, id) => {
      dispatch(setChosenCard(type, id))
    },
    calculateOdds: (callback) => {
      dispatch(calculateOdds(callback))
    },
    getWinnerHand: () => {
      dispatch(getWinnerHand())
    },
    setWinner: (winner) => {
      dispatch(setWinner(winner))
    },
    reset: () => {
      dispatch(reset())
    },
  }
};

const mapStateToProps = (state) => {
  return getPreparedBoardProps(state);
};

export default connect(mapStateToProps, mapDispatchToProps)(Board);